// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import { Regex } from '../../_common/api/regex';
import Button from '../../_common/form/Button';
import Form from '../../_common/form/Form';
import Input from '../../_common/form/Input';
import Select from '../../_common/form/Select';
import Title from '../../_common/form/Title';
import { useGlobalState } from '../../_common/globalState/GlobalStateProvider';
import Loading from '../../_common/Loading';
import Modal from '../../_common/Modal';
import Card from '../Card';
import ItemList from '../ItemList';
import WashClub from '../WashClub';
import { DeleteButton } from './Account';
import ForceLocation from '../ForceLocation';
import { HamQuest } from '../../../App';
import Survey from './Survey';
import UpdateVehicle from './UpdateVehicle';

const Row = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`
const Span = styled.span`
    text-align: center;
`

const WashClubs = () => {
    const {
        state: {
            active_user, 
        },
        getWashClub
    } = useGlobalState();

    const { search } = useLocation();
    const query = new URLSearchParams(search);

    const [plans, setPlans] = useState([]);
    const [showingPlans, setShowingPlans] = useState(
        query.get('forced') ?
            true :
            active_user.washClub ?
                active_user.washClub.status.toLowerCase() === 'inactive' : true
    );

    // Temporary flag to disable surveys.
    const displaySurvey = true;

    const [washClubStatus, setWashClubStatus] = useState(
        active_user.washClub ? active_user.washClub.status.toLowerCase() : 'inactive'
    );

     useEffect(() => {
        setWashClubStatus(active_user.washClub ? active_user.washClub.status.toLowerCase() : 'inactive');
      }, [active_user.washClub ? active_user.washClub.status.toLowerCase() : 'inactive']); 

    const updateWashClubStatus = async () => {
        await getWashClub();
    }

    const cancelPlan = () => {
        Modal.Confirmation({
            title: 'Hold On!',
            type: 'warning',
            body: `Are you sure you want to cancel your Wash Club?`,
            hideClose: true,
            closeAfter: true,
        }).then((res) => {
            if (!res) return;
            Modal.Confirmation({
                title: 'LAST CHANCE!',
                type: 'error',
                body: `Are you sure you want to cancel your Wash Club? You will be able to use the club until the next billing date.`,
                hideClose: true,
                closeAfter: true,
            }).then(res => {
            if (!res) return;
            return displaySurvey ? 
                Modal.Show({
                    title: 'Survey',
                    body: <Survey onSuccess={() => {
                        Modal.Close();
                        return true;
                    }} />,
                    buttons: [],
                    hideClose: true,
                    closeAfter: true,
                }) 
                : res;
        }).then(res => {
            if (!res) return;
                HamQuest.delete(QuestRoute.user.washClub)
                    .then((res) => {
                        updateWashClubStatus();
                        Modal.Show({
                            type: 'success',
                            title: 'Wash Club Canceled',
                            body: 'You can continue to use your wash club until your next billing date.'
                        })
                    })
                    .catch((ex) => {
                        Modal.Show({
                            type: 'error',
                            title: 'Failed to Cancel',
                            body: 'Sorry, something went wrong. Please try again.'
                        })
                    })
                })
        });
    };

    const reactivatePlan = () => {
        Modal.Confirmation({
            title: 'Activate Washclub.',
            type: 'warning',
            body: `Are you sure you want reactivate your Wash Club?`,
            hideClose: true,
            closeAfter: true,
        }).then(res => {
            if (!res) return;
                HamQuest.put(QuestRoute.user.washClub)
                    .then((res) => {
                        updateWashClubStatus();
                        Modal.Show({
                            type: 'success',
                            title: 'Wash reactivated',
                            body: 'Your wash club has been reactivated.'
                        })
                    })
                    .catch((ex) => {
                        Modal.Show({
                            type: 'error',
                            title: 'Failed to Reactivate',
                            body: 'Sorry, something went wrong. Please try again.'
                        })
                    })
        });
    };

    useEffect(() => {
        HamQuest.get(QuestRoute.products.washClubs)
            .then((res) => setPlans(res))
            .catch(ex => {
                Modal.Show({
                    type: 'error',
                    title: 'Unable to get Clubs',
                    body: 'Sorry, something went wrong. Please try again.'
                })
            })
    }, [])

    if(active_user.vehicle){
        if(active_user.vehicle.make && active_user.vehicle.model && active_user.vehicle.year && active_user.vehicle.color && active_user.vehicle.license && active_user.vehicle.state){
        if (showingPlans) {
            return (
                <ForceLocation route='washClub'>
                    <ItemList items={plans} />
                </ForceLocation>
            )
        }

     
        return <> 
            <WashClub generate={true} />
            <Card>
                <Button onClick={() => setShowingPlans(!showingPlans)}>View Clubs</Button>

                {console.log("userId: " + active_user.account.userId)}
                { washClubStatus === 'endbillingpending' ? <Button onClick={reactivatePlan}>Reactivate Plan</Button> : null }

                {    
                    (washClubStatus === 'active' || washClubStatus === 'endbillingpending') ?
                    <Button onClick={cancelPlan}>Cancel Plan</Button>
                    : null
                }
                
            </Card>
        </>
        }else{
            return  <UpdateVehicle />   
        } 
    }else{
        return  <UpdateVehicle />   
    } 
    
}

export default WashClubs;

export const AddVehicle = () => {
    const {
        state: {
            site_config,
        },
        getVehicle
    } = useGlobalState();

    const addVehicle = () => {
        Modal.Show({
            title: 'Vehicle Info',
            body: (
                <Form
                    inputs={{
                        make: '',
                        model: '',
                        year: '',
                        license: '',
                        color: '',
                        state: '',
                    }}
                    onSubmit={e =>
                        Modal.Promise({
                            title: 'Saving Vehicle',
                            body: <Loading />,
                            callback: HamQuest.post(QuestRoute.user.vehicle, e)
                        })
                            .then(() => {
                                Modal.Close();
                                getVehicle();
                            })
                    }
                >
                    <Select
                        label='State'
                        name='state'
                        required
                        options={
                            [
                                {
                                    value: 0,
                                    label: '-'
                                },
                                ...site_config.states
                            ]
                        }
                    />
                    <Input
                        name='make'
                        label='Make'
                        maxLength={20}
                        required
                    />
                    <Input
                        name='model'
                        label='Model'
                        maxLength={20}
                        required
                    />
                    <Input
                        name='color'
                        label='Color'
                        maxLength={20}
                        required
                    />
                    <Input
                        name='year'
                        label='Year'
                        sanitize={Regex.match.notNumbers}
                        numpad
                        maxLength={4}
                        required
                    />
                    <Input
                        name='license'
                        label='License Plate'
                        required
                        maxLength={10}
                        sanitize={Regex.match.specialChar}
                        validate={/(\w|\d)+/g}
                        mask={(e) => e.toUpperCase()}
                        tag='Used for License Plate Reading'
                    />
                </Form>
            )
        })
    }

    return (
        <Row>
            <Title icon='car'>Hold On!</Title>
            <Span>Your Vehicle Information is required for a wash club plan.</Span>
            <Button onClick={addVehicle}>Add Vehicle Info</Button>
        </Row>
    )
}